import { Directive, ElementRef, EventEmitter, Input, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dynamicFormRow]',
})
export class DynamicFormRowDirective {
  @Input('elmType') type: string;
  @Input('baseClassNames') baseClassNames: String;
  @Output('allowAddNewColumn') private allowAddNewColumnEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterContentChecked() {
    let elTypes = this.el.nativeElement.parentElement.querySelectorAll(this.type);
    elTypes.forEach((element) => {
      this.renderer.setAttribute(element, 'style', 'flex-grow: 1');
    });

    let parentElement = this.el.nativeElement.parentElement;
    this.allowAddNewColumnEvent.emit(true);
  }
}
